import VacancyCard from './VacancyCard.component';

export default VacancyCard;